import { render } from "./importView.vue?vue&type=template&id=20511322&scoped=true"
import script from "./importView.vue?vue&type=script&lang=js"
export * from "./importView.vue?vue&type=script&lang=js"

import "./importView.vue?vue&type=style&index=0&id=20511322&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20511322"]])

export default __exports__